import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { useSearch } from "./search-context";

const FraudPreventionConsent = ({
  defaultValue,
}: {
  defaultValue: boolean;
}) => {
  const [state, setState] = useState(defaultValue);
  const { updateFormData: update } = useSearch();

  useEffect(() => {
    setState(defaultValue);
  }, [defaultValue]);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;

    setState(checked);
    update({ fraudDtectionConsent: checked });
  };

  return (
    <Grid
      size={{ xs: 4 }}
      alignItems="end"
      display="flex"
      justifyContent="flex-end"
    >
      <FormControlLabel
        control={<Checkbox checked={state} onChange={handleCheckboxChange} />}
        label={
          <Typography variant="body2" fontSize={12} color="text.secondary">
            In conducting this search I confirm that the enquiry is conducted
            solely for the purpose of the detection and prevention of fraud in
            accordance with Section 15 & Schedule 2 part 1 paragraph 2 of the
            Data Protection Act 2018
          </Typography>
        }
        sx={{
          fontSize: "12px",
          marginTop: 2,
          width: "100%",
        }}
      />
    </Grid>
  );
};

export default FraudPreventionConsent;
